module.exports = __webpack_public_path__ + "img/programs.a9c71c1a.png";